// extracted by mini-css-extract-plugin
module.exports = {"cancelTextStyle":"ProjectOwnerCancelRequest_cancelTextStyle_1_fKu","spinAround":"ProjectOwnerCancelRequest_spinAround_2xHw2"};